<template>
  <div id="login-bg" class="">

    <div class="text-center pt-14">
      <img class="w-2/4 mx-auto" src="../assets/img/logo.png">
      <h1 class=" text-white text-xl font-bold mt-6">{{ $t('hotel_tabarok') }}</h1>
      <h5 class=" text-gray-300 text-sm mt-2">{{ $t('login_page_message') }}</h5>
    </div>

    <div class="fixed w-full bottom-16 bg-gray-300 p-8 rounded-t-xl">
      <h1 class="text-gray-700 text-center font-bold">{{ $t('login_page_message') }}</h1>

      <h6 class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500" v-if="loginError">
        {{ loginError }}
      </h6>

      <select class="border p-1.5 rounded-lg text-black w-full mt-4"
              v-model="language">
        <option
            v-for="lang in languages"
            :key="lang.id"
            :value="lang">
          {{ lang.name }}
        </option>
      </select>

      <form action="" @submit.prevent="showPasswordInput ? login() : getOTP()">
        <VInput type="tel"
                class="w-full mt-4"
                :placeholder="$t('cell_number')"
                v-model="inputPhone.value"
                :disabled="showPasswordInput"
                :error="inputPhone.error"
                @keydown="inputPhone.error = ''"
                required/>
        <span class="text-xs text-red-500" v-if="inputPhone.error">{{ inputPhone.error }}</span>

        <VInput type="number"
                class="w-full mt-4"
                placeholder="کد تایید"
                v-model="password"
                :class="{'hidden' : !showPasswordInput}"
                :disabled="!showPasswordInput"
                required/>

        <VButton class="w-full mt-4 shadow-lg" type="submit">{{ $t('login')}}</VButton>

      </form>
    </div>

  </div>

</template>

<script>
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";
import {getOTP} from "@/API/API";
import {mapState} from "vuex";

export default {
  name: "LoginPage",
  components: {VButton, VInput},
  data() {
    return {
      inputPhone: {
        value: '',
        error: '',
      },
      password: '',
      showPasswordInput: false,
      reLogin: false,
      loginError: false,
      language: {}
    }
  },
  computed: {
    ...mapState(['languages', 'locale'])
  },
  created() {
    this.reLogin = this.$route.query.reLogin
  },
  methods: {
    async getOTP() {
      if (this.validatePhoneNumber()) {
        getOTP(this.inputPhone.value)
            .then(resp => {
              this.showPasswordInput = true
              this.password = resp.data.password
              this.$swal({
                icon: 'success',
                title: 'موفق',
                text: resp.data.message,
                confirmButtonColor: '#fcd34d',
                confirmButtonText: 'باشه'
              })
            })
      }
    },
    login() {
      let user = {
        phone: this.inputPhone.value,
        password: this.password
      }
      this.$store.dispatch('login', user)
          .then(() => {
            this.$router.replace('/')
          })
          .catch((err) => {
            this.loginError = err
          })
    },
    validatePhoneNumber() {
      let result = true

      if (!this.inputPhone.value) {
        this.inputPhone.error = "لطفا شماره خود را وارد کنید"

        result = false
      } else if (this.inputPhone.value.length !== 11) {
        this.inputPhone.error = "شماره همراه باید 11 رقم باشد"

        result = false
      } else if (this.inputPhone.value.substr(0, 2) !== '09') {
        this.inputPhone.error = "شماره همراه باید با 09 شروع شود"

        result = false
      }

      return result
    },
  },
  watch: {
    languages() {
      this.language = this.languages.find(lang => lang.code === this.locale)
    },
    language() {
      this.$store.dispatch('setLocale', this.language.code)
    },
  }
}
</script>

<style scoped>
#login-bg {
  content: '';
  background-image: url("@/assets/img/bg_login.png");
  @apply h-screen w-screen bg-no-repeat bg-cover
}
</style>